import type { ItemUnitTranslationEntity } from "./ItemUnitTranslationEntity";

export class ItemUnitEntity {
    id?: number;
    isActive?: boolean;
    translations?: Array<ItemUnitTranslationEntity> | null;
}
